import React, { useContext, useEffect, useRef, useState } from "react"
import styled, { keyframes } from "styled-components"
import { LazyLoadImage } from "react-lazy-load-image-component"
import { Button, Icon, Loader } from "semantic-ui-react"
import { device } from "../../theme"
import { handleCharacters } from "../../utils/handleCharacters"
import { FilterContext } from "../../providers/FilterProvider"
import { isElementInViewport } from "../../utils/isElementInViewport"
import { throttle } from "../../utils"
import icon from "../../images/favicon.png"
import { FavoritesContext } from "../../providers/MyFavorites"
import { Link } from "gatsby"

const Container = styled.div`
  height: 470px;
  background: #fcfcfc;
  border-radius: 4px;
  // overflow: hidden;
  // box-shadow: 0 0 12px 1px #f2f2f2;
  transition: 0.3s linear;
  opacity: 0.3;
  transform: translateY(0);
  // background: #fff;
  border-radius: 12px;

  &.in-view {
    opacity: 1;
    transform: translateY(-8px);
  }

  @media ${device.phone} {
    height: 330px;
    box-shadow: 0 0 12px 1px #f2f2f2;
  }

  &:hover {
    box-shadow: 0 0 12px 6px #f0f0f0;
    // .info-container {
    //   transform: translateY(-6px);
    // }

    .buy-link {
      transform: translateY(6px);
    }

    .bottom-line {
      opacity: 1;
    }

    .product-image {
      // transform: scale(1.02, 1.02);
    }
  }
`

const ImageContainer = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 75%;
  // overflow: hidden;
  transition: transform 0.2s ease-in;
  cursor: pointer;

  &.half {
    height: 60%;
  }

  @media ${device.phone} {
    height: 70%;
    align-items: flex-start;
  }
`

const Image = styled(LazyLoadImage)`
  height: 100%;
  width: 100%;
  object-fit: cover;
  margin-bottom: 0;
  transition: 0.2s linear;
  text-indent: -9999px;
  border-radius: 12px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`

const InfoContainer = styled.div`
  height: 25%;
  padding: 22px 12px 12px;
  position: relative;
  transition: transform 0.2s ease-in;

  &.half {
    height: 40%;
  }

  @media ${device.phone} {
    height: 30%;
    padding: 22px 12px;
  }
`

const BuyButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin-right: 12px;
  height: 40px;
  width: 40px;
  // border: 2px solid #e2e2e2;
  color: #fff !important;
  background: ${props => props.theme.colors.green};
  // box-shadow: 0 0 0 6px rgb(255, 99, 71, 0.3);
  transition: box-shadow 0.1s ease-in-out;
  &:hover {
    color: ${props => props.theme.colors.green};
  }

  .icon {
    margin: 0;
  }
`

const Title = styled.h3`
  font-size: 0.8rem;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media ${device.phone} {
    height: 18px;
  }
`

const Brand = styled.p`
  margin: 6px 0;
  font-size: 0.75rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media ${device.phone} {
    margin: 0;
    max-width: 100%;
    height: 20px;
  }
`

const Price = styled.p`
  margin: 0;
  font-size: 0.9rem;
  font-weight: bold;
`

const OldPrice = styled.span`
  text-decoration: line-through;
  margin: 0;
  font-size: 0.8rem;
  min-height: 20px;
`

const BottomLine = styled.div`
  height: 6px;
  width: 100%;
  display: none;
  opacity: 0.6;
  transition: opacity 0.2s ease-in-out;
  background: ${props => props.theme.colors.green};

  @media ${device.tablet} {
    display: none;
  }
`

const Buttons = styled.div`
  position: absolute;
  bottom: -18px;
  right: 0px;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media ${device.phone} {
  }

  &.is-favorite {
    background: red;
  }
`

const FavoriteButton = styled.button`
  outline: none;
  border: none;
  margin-right: 12px;
  background: #fcfcfc;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: 1px solid #e2e2e2;

  .icon {
    margin: 0 !important;
  }
`

const SavedNote = styled.div`
  position: absolute;
  top: 50%;
  text-align: center;
  left: 50%;
  font-size: ${props => (props.isVisible ? "18px" : "0")};
  opacity: ${props => (props.isVisible ? "1" : "0")};
  transform: ${props =>
    props.isVisible ? "translate(-50%, -50%)" : "translate(-50%, -45%)"};
  transition: opacity 0.2s ease-in, transform 0.2s ease-in, font-size 0s;
  p {
    margin-top: 6px;
    padding: 2px;
    background: #fff;
    white-space: nowrap;
  }
`

const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 99999999999;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
`
const PopContainer = styled.div`
  max-width: 520px;
  background: #fff;
`

const PopImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const fadeIn = keyframes`
0% {
  box-shadow: 0 0 0 6px rgba(255, 99, 71, 0.1);
}

50% {
  box-shadow: 0 0 0 6px rgba(255, 99, 71, 0.9);
}

100% {
  box-shadow: 0 0 0 6px rgba(255, 99, 71, 0.1);
}
`

const LoadingImg = styled.img`
  display: block;
  height: 64px;
  width: 64px;
  margin-left: -31px;
  margin-top: -31px;
  border: 6px solid white;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 50%;
  animation: ${fadeIn} 2s linear infinite;
`

const StyledLink = styled(Link)`
  color: inherit;
  &:hover {
    color: inherit;
  }
`

const BuyLink = styled.a`
  color: inherit;
  &:hover {
    color: inherit;
  }
`

const Discount = styled.label`
  background: ${props => props.theme.colors.green};
  color: white;
  font-weight: bold;
  padding: 4px 6px;
  border-radius: 12px;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0;
  font-size: 16px;
  display: block;
  position: absolute;
  right: 0;
  top: 0;
  margin: 0 auto;
  text-decoration: line-through;
`

function ProductCard({
  brand,
  price,
  store,
  oldPrice,
  title,
  image,
  url,
  id,
  shopId,
  affiliate,
  productKey,
  productPath,
  productCategory,
  categoryPage,
}) {
  const elementRef = useRef()
  const { state } = useContext(FilterContext)
  const { favorites, setFavorites } = useContext(FavoritesContext)
  const [isFavorite, setIsFavorite] = useState(false)
  const [isSelected, setSelected] = useState(false)
  const [popupVisible, setPopup] = useState(false)
  const [inView, setInView] = useState(false)
  const [imageLoading, setLoading] = useState(true)

  const beautifyURL = title =>
    title
      .replace(/\s/g, "-")
      .replace(/-+/g, "-")
      .replace(/[^a-å0-9-]/gi, "")
      .toLowerCase()

  const addToFavorite = () => {
    const unique = `${productKey}-${id}`
    const details = {
      title,
      price,
      image,
      url,
      brand,
      oldPrice,
      id,
      key: unique,
    }

    if (!favorites.length) {
      setSelected(true)
      setIsFavorite(true)
      setFavorites([...favorites, details])
      window.localStorage.setItem("favorite", JSON.stringify(favorites))
      setTimeout(() => {
        setSelected(false)
      }, 1500)
    } else {
      let exist = false
      favorites.forEach(prod => {
        if (prod.key === unique) {
          exist = true
        }
      })

      if (exist) {
        setIsFavorite(false)
        const removeProduct = favorites.filter(prod => prod.key !== unique)
        setFavorites(removeProduct)
        window.localStorage.setItem("favorite", JSON.stringify(removeProduct))
      } else {
        setSelected(true)
        setIsFavorite(true)
        setFavorites([...favorites, details])
        window.localStorage.setItem(
          "favorite",
          JSON.stringify([...favorites, details])
        )
        setTimeout(() => {
          setSelected(false)
        }, 1500)
      }
    }
  }

  useEffect(() => {
    const unique = `${productKey}-${id}`
    if (!favorites.length) return

    favorites.forEach(prod => {
      if (prod.key === unique) {
        setIsFavorite(true)
      }
    })
  }, [state.filteredProducts])

  const highlightInView = () => {
    if (isElementInViewport(elementRef.current, 0)) {
      setInView(true)
      return
    }
  }

  useEffect(() => {
    highlightInView()
    document.body.addEventListener("scroll", throttle(highlightInView, 200))
    return () =>
      document.body.removeEventListener(
        "scroll",
        throttle(highlightInView, 200)
      )
  }, [])

  const handleImageSize = store => {
    if (store === "Nike" || store === "Kaufmann" || store === "Quint") {
      return " half"
    }

    return ""
  }

  return (
    <>
      <Container className={inView ? "in-view" : ""} ref={elementRef}>
        <ImageContainer className={`image-container${handleImageSize(store)}`}>
          <Image
            onClick={() => setPopup(true)}
            className="product-image"
            src={image}
            alt={title}
            afterLoad={() => setLoading(false)}
          />
          {oldPrice && <Discount>{oldPrice} kr</Discount>}
          <Buttons>
            <FavoriteButton onClick={() => addToFavorite()}>
              <Icon color={isFavorite ? "red" : "black"} name="heart outline" />
            </FavoriteButton>
            <BuyButton as={"a"} href={url} target="_blank" rel="noopener">
              <Icon name="shopping basket" size="large" />
            </BuyButton>
          </Buttons>
          {imageLoading && <LoadingImg src={icon} alt="Loading" />}
          <SavedNote isVisible={isSelected}>
            <Icon color="red" name="heart outline" size="large" />{" "}
            <p>Føjet til favoritter</p>
          </SavedNote>
        </ImageContainer>
        <InfoContainer className={`info-container${handleImageSize(store)}`}>
          {affiliate === "partner-ads" || affiliate === "adtraction" ? (
            <StyledLink
              exact
              to={`/${productPath}/${categoryPage}/${beautifyURL(title)}-${shopId}-${id}`}
            >
              <Title>{title}</Title>
            </StyledLink>
          ) : (
            <BuyLink href={url} target="_blank" rel="noopener">
              <Title className="product-title">{title}</Title>
            </BuyLink>
          )}
          <Brand>{handleCharacters(brand)}</Brand>
          <Brand>{store}</Brand>
          <Price>{price} kr</Price>
        </InfoContainer>
        <BottomLine className="bottom-line" />
      </Container>
      {popupVisible && (
        <Popup onClick={() => setPopup(false)}>
          <PopContainer>
            <PopImage src={image} alt={title} />
          </PopContainer>
        </Popup>
      )}
    </>
  )
}

export default ProductCard
